import React from 'react';
import './resumeSelfcare360.css';

const Dot = ({ color }) => (
    <span className="selfcare360-legend-dot" style={{ backgroundColor: color }} />
);

export const DimensionsLegendSelfcare360 = () => {
    return (
        <div className="selfcare360-legend-box">
            <div className="selfcare360-legend-title">Dimensiones</div>
            <div className="selfcare360-legend-grid">
                <div className="selfcare360-legend-row">
                    <Dot color="#43a047" />
                    <div className="selfcare360-legend-range">&gt;=85</div>
                    <div className="selfcare360-legend-name">Riesgo bajo</div>
                    <div className="selfcare360-legend-desc">Práctica consistente y control estable</div>
                </div>
                <div className="selfcare360-legend-row">
                    <Dot color="#fbc02d" />
                    <div className="selfcare360-legend-range">75-84</div>
                    <div className="selfcare360-legend-name">Riesgo moderado</div>
                    <div className="selfcare360-legend-desc">Se requiere plan preventivo y seguimiento</div>
                </div>
                <div className="selfcare360-legend-row">
                    <Dot color="#fb8c00" />
                    <div className="selfcare360-legend-range">65-74</div>
                    <div className="selfcare360-legend-name">Riesgo alto</div>
                    <div className="selfcare360-legend-desc">Intervención prioritaria sobre la dimensión</div>
                </div>
                <div className="selfcare360-legend-row">
                    <Dot color="#e53935" />
                    <div className="selfcare360-legend-range">&lt;65</div>
                    <div className="selfcare360-legend-name">Riesgo crítico</div>
                    <div className="selfcare360-legend-desc">Acción inmediata por exposición severa</div>
                </div>
            </div>
        </div>
    );
};

export const IpraLegendSelfcare360 = () => {
    return (
        <div className="selfcare360-legend-box">
            <div className="selfcare360-legend-title">IPRA</div>
            <div className="selfcare360-legend-grid">
                <div className="selfcare360-legend-row">
                    <Dot color="#43a047" />
                    <div className="selfcare360-legend-range">&gt;=85</div>
                    <div className="selfcare360-legend-name">Riesgo bajo</div>
                    <div className="selfcare360-legend-desc">Mantener</div>
                </div>
                <div className="selfcare360-legend-row">
                    <Dot color="#fbc02d" />
                    <div className="selfcare360-legend-range">75-84</div>
                    <div className="selfcare360-legend-name">Riesgo moderado</div>
                    <div className="selfcare360-legend-desc">Plan preventivo</div>
                </div>
                <div className="selfcare360-legend-row">
                    <Dot color="#fb8c00" />
                    <div className="selfcare360-legend-range">65-74</div>
                    <div className="selfcare360-legend-name">Riesgo alto</div>
                    <div className="selfcare360-legend-desc">Intervención prioritaria</div>
                </div>
                <div className="selfcare360-legend-row">
                    <Dot color="#e53935" />
                    <div className="selfcare360-legend-range">&lt;65</div>
                    <div className="selfcare360-legend-name">Riesgo crítico</div>
                    <div className="selfcare360-legend-desc">Acción inmediata</div>
                </div>
            </div>
        </div>
    );
};
